import TitleBlock from '@anm/components/TitleBlock';
import styled from 'styled-components';

export const EmptyListMessage = styled(TitleBlock)`
  margin-top: 56px;
  text-align: center;
  h3 {
    font-weight: 700;
    font-size: 16px;
    line-height: 22px;
    color: ${({ theme }) => theme.destinationsEmptyTextColor};
  }
`;
